import BaseMapper from './base';
import { Component, ImageProps } from '../types';

export enum ImageTargetsEnum {
  option1 = 'Both',
  option2 = 'Desktop',
  option3 = 'Mobile',
}
export type ImageTargets = 'Both' | 'Desktop' | 'Mobile';

class ModuleImage extends BaseMapper {
  public async generateComponent(): Promise<Component<ImageProps>> {
    return {
      name: 'Image',
      props: this.getProps(),
    };
  }

  private getProps(): ImageProps {
    const textLanguageFields = this.mapTextLanguageFields<ImageProps>({
      fieldsToMap: [{ key: 'module_image_alt', mappedKey: 'alt' }],
    });
    const isGrey = this.mapBoolContent({ contentKey: 'module_image_grey' });
    const lazy = this.mapBoolContent({
      contentKey: 'module_image_disable_lazy_load',
    });
    const targetDevice = this.mapValueFromEnum<ImageTargets>({
      typeEnum: ImageTargetsEnum,
      contentKey: 'target_device',
    });
    const src = this.mapContentField<string>({
      contentKey: 'module_image_src',
      defaultValue: '',
    });

    const componentProps: ImageProps = {
      ...textLanguageFields,
      isGrey,
      lazy,
      targetDevice,
      src,
    };

    return componentProps;
  }
}

export default ModuleImage;
